import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AlertService } from './alert.service';
import { Router } from '@angular/router';
import { Store } from '../store';
import { catchError, map, tap } from 'rxjs/operators';
import { CookieService } from './cookie.service';
import { environment } from '../../environments/environment';
import { StorageService } from './storage.service';
import { CmsService } from '../cms/cms.service';
import { ApiAuthHttpClient } from '../http/ApiAuthHttpClient';
import {of} from 'rxjs';
import { PosthogService } from './posthog.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    env = environment;

    body = document.getElementsByTagName('body')[0];

    authInterval;

    constructor(
        private apiService: ApiService,
        private alertService: AlertService,
        private router: Router,
        private store: Store,
        private http: ApiAuthHttpClient,
        private cookieService: CookieService,
        private storageService: StorageService,
        private cmsService: CmsService,
        private posthogService: PosthogService,
    ) {
    }

    login(user) {
        return this.http.post(this.env.apiPath + 'users/login/admin', user, this.apiService.getHttpOptions())
            .pipe(
                tap((data: any) => {
                    this.store.set('loggedIn', true);

                    this.store.set('user', data.data.returnData.user);
                    this.store.set('accountType', data.data.returnData.user.accountType);
                    
                    this.cookieService.setLoggedIn(true);
                    this.storageService.setLoggedIn(true);

                    this.cookieService.setUser(data.data.returnData.user);
                    this.storageService.setUser(data.data.returnData.user);

                    // Monitoring: tie subsequent admin events/replays to this user.
                    const u = data.data.returnData.user;
                    if (u && u.id) {
                        this.posthogService.identify(u.id, { accountType: u.accountType });
                    }
                    this.posthogService.capture('admin_logged_in', { accountType: u && u.accountType });
                }),
                map(data => {
                    this.cmsService.getSettings().subscribe();
                    return data;
                }),
                catchError(this.apiService.handleError));
    }

    logout(removeCookie: boolean = true) {
        this.cookieService.remove();
        this.storageService.remove();
        this.store.set('token', '');
        this.store.set('loggedIn', false);
        this.store.set('user', undefined);
        this.posthogService.reset();
        if (removeCookie) {
            return this.http.post(this.env.apiPath + 'users/logout', {}, this.apiService.getHttpOptions());
        }
        return of(undefined);
    }

    passwordReset(email) {
        const dataToSend = {
            email,
        };
        return this.http.post(this.env.apiPath + 'users/admin/password/reset', dataToSend, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data;
                },
                    catchError(this.apiService.handleError)
                ));
    }


    passwordSet(resetData) {
        return this.http.post(this.env.apiPath + 'users/admin/password/set', resetData, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data;
                },
                    catchError(this.apiService.handleError)
                ));
    }

    // authTimeout() {
    //     this.authInterval = setInterval(() => {
    //         let ttl = this.store.selectForLocal('ttl');
    //         ttl--;
    //         this.store.set('ttl', ttl);
    //         if (ttl === 0) {
    //             this.logout();
    //         }

    //     }, 50000);
    // }

    // resetAuthTimeout() {
    //     this.store.set('ttl', 1000); // reset to 10
    // }

    // clearAuthTimeout() {
    //     clearInterval(this.authInterval);
    // }

}
